import React, { useEffect, useState } from 'react'
import { useTrivia } from '../../hooks/useTrivia'
import { RenderLanding } from '../../config/types/triviaTypes'
// @ts-ignore
import * as Bouncer from 'formbouncerjs'

const URL_RENDER_DATA = `${window.location.origin}/aguila/loyalty/landing-assets-trivia`
const RENDER_LANDING: RenderLanding = {
  "title": {
    "value": "",
    "format": "",
  },
  "copy": {
    "value": "",
    "format": "",
  },
  "button": {
    "uri": "",
    "title": "",
    "options": []
  },
  "sound": {
    "value": ""
  },
  "tyc": {
    "format":"",
    "value": ""
  },
  "code": 0
}

const LandingTrivia = () => {
  const fetchQuestions = useTrivia(state => state.fetchQuestions)
  const [data, setData] = useState(RENDER_LANDING)

 function handleInitTrivia() {
    fetchQuestions()
  }

  async function getDataRender() {
    fetch(URL_RENDER_DATA)
      .then(res => res.json())
      .then(data => {
        if (data.code === 0) window.location.href = `${window.location.origin}/estadio-aguila/iniciar-sesion`

        if (data.code === 2) {
          setData(data)
          if(data.sound.value) {
            useTrivia.setState({audio: new Audio(`${window.location.origin}${data.sound.value}`)})
          }
        }
      })
  }

  useEffect(() => {
    getDataRender()
  }, [])

  useEffect(() => {
    new Bouncer('#tyc-loyalty-trivia', {
      messages: {
        missingValue: {
          checkbox: 'Este campo es obligatorio',
        }
      },
      disableSubmit: true
    })

    document.addEventListener('bouncerFormValid', handleInitTrivia);
    return () => {
      document.removeEventListener('bouncerFormValid', handleInitTrivia);
    };
  }, [])

  return (
    <>
      {
        data.code === 2 &&
        <section className="loyal-trivia_landing">
          <p className="loyal-trivia_title whiteShadow" dangerouslySetInnerHTML={{ __html: data.title.value }}></p>
          <p className="loyal-trivia_text whiteShadow" dangerouslySetInnerHTML={{ __html: data.copy.value }}></p>

          <form id='tyc-loyalty-trivia' noValidate>
            <input type="checkbox" name="tyc-trivia" id="tyc-trivia" required />
            <label className='loyal-trivia_tyc-text whiteShadow' htmlFor="tyc-trivia" dangerouslySetInnerHTML={{ __html: data?.tyc?.value }}></label>
            <div className='error-message-container'></div>

            <div className='loyal-trivia_btn-container'>
              <button type="submit" className='newBottom--smallYellow loyal-trivia_landing-btn'>{data.button.title}</button>
              <a href="/estadio-aguila/codigo-tada" className='newBottom--smallYellow loyal-trivia_landing-btn loyal-trivia_hidden'>CANJEAR CÓDIGO</a>
            </div>
          </form>
        </section>
      }
    </>
  )
}

export default LandingTrivia